export const isDeliveryNoteTypes = ["1.1", "1.2", "1.3", "1.4", "3.1", "3.2", "5.1", "5.2", "11.1", "11.4", "11.5"];